<template>
  <ModalForm
    v-model="formData"
    class="modal--md modal__reserve-material"
    title="Резерв проволоки"
    text-btn-confirm="Сохранить"
    text-btn-reject="Отмена"
    @request="onRequest"
    @reject="onReject"
  >
    <div class="column gap-s mb-20">
      <InfoTextBlock label-text="Материал" :text="getMaterialName" />
      <InfoTextBlock label-text="d пров." :text="dWire" />
      <InfoTextBlock label-text="Длина развертки" :text="sweepLength" />
    </div>
    <div v-for="(row, idx) in rows" :key="row.id" class="section--gray column gap-s mb-10">
      <div class="d-flex gap-10 ai-fe">
        <VSelect
          v-model="row.rodLength"
          :options="rodLengths"
          item-text="length_and_count"
          single-label-text="length"
          label="Длина прутка, м:"
          :required="isRequired"
          @change="updateTotalWeight(row)"
        >
          <Validation for="required" />
        </VSelect>
        <VInput
          v-model="row.count"
          label="Кол-во шт.:"
          :required="isRequired"
          :pattern="/^\d+$/"
          @input="updateTotalWeight(row)"
        >
          <Validation for="required" />
          <Validation for="pattern">Только целое число</Validation>
        </VInput>
      </div>
      <div class="d-flex gap-s ai-fe">
        <VInput
          v-model="row.totalWeight"
          label="Итого, кг:"
          :pattern="/^[0-9]\d*[.,]?(\d{0,3}?)$/"
        >
          <Validation for="pattern">Только цифры с точностью до тысячных</Validation>
        </VInput>
        <div class="d-flex gap-s mt-5">
          <VButton
            v-if="idx === rows.length - 1"
            icon="create"
            size="md"
            color="primary-sm"
            @click.native="addRow"
          />
          <VButton
            icon="remove"
            size="md"
            @click.native="removeRow(idx)"
          />
        </div>
      </div>
    </div>
  </ModalForm>
</template>

<script>
import ModalForm from '@/components/ui/Modal/ModalForm.vue'
import VInput from '@/components/Form/Vinput/VInput'
import VSelect from '@/components/Form/VSelect.vue'
import VButton from '@/components/simple/button/VButton.vue'
import Validation from '@/components/Form/Validation.vue'
import { getNextId } from '@/utils/array/getNextId'
import InfoTextBlock from '@/components/ui/AppInfoTextBlock.vue'
import { mapActions } from 'vuex'
import { toNum } from '@/utils/string'

export default {
  name: 'ModalReserveMaterial',
  components: { InfoTextBlock, ModalForm, VInput, VSelect, VButton, Validation },
  props: {
    material: {
      type: Object,
      default: null
    },
    dWire: {
      type: [String, Number],
      default: null
    },
    sweepLength: {
      type: [String, Number],
      default: null
    },
    rodLengths: {
      type: Array,
      required: true
    },
    reserveData: {
      type: Array,
      default: null
    },
    positionId: {
      type: [String, Number],
      required: true
    }
  },
  data () {
    return {
      formData: {},
      isRequired: true,
      rows: this.reserveData.length
        ? this.reserveData.map(item => ({
          id: item.id,
          rodLength: this.rodLengths.find(opt => opt.id === item?.warehouse_material_id) || null,
          rodLengthId: item?.warehouse_material_id,
          count: item?.count || null,
          totalWeight: item?.amount || null
        }))
        : [this.createRow()]
    }
  },
  watch: {
    rodLengths: {
      handler (newRodLengths) {
        if (newRodLengths.length) {
          this.rows.forEach(row => {
            if (row.rodLengthId && !row.rodLength) {
              row.rodLength = newRodLengths.find(opt => opt.id === row.rodLengthId)
            }
          })
        }
      },
      immediate: true
    }
  },

  computed: {
    getMaterialName () {
      return this.material?.name || null
    }
  },

  methods: {
    ...mapActions('orderDetail', ['setReserveMaterial']),
    createRow () {
      return {
        id: getNextId(this.rows),
        rodLength: null,
        count: '',
        totalWeight: ''
      }
    },
    addRow () {
      this.rows.push(this.createRow())
    },
    // Удаление строки
    removeRow (index) {
      // Если строка одна, не удаляем её, а очищаем
      if (this.rows.length === 1) this.clearRow(index)
      if (this.rows.length > 1) this.rows.splice(index, 1)
    },
    // Очищение строки
    clearRow (index) {
      this.$set(this.rows, index, {
        ...this.rows[index],
        rodLength: null,
        rodLengthId: null,
        count: '',
        totalWeight: ''
      })
      // Снимаем обязательность, чтобы после очищения можно было сохранить
      this.isRequired = false
    },
    updateTotalWeight (row) {
      if (row.rodLength && row.count) {
        row.totalWeight = (+row.rodLength.weight_by_one * toNum(row.count)).toFixed(3)
      }
    },
    async onRequest (data) {
      try {
        this.$store.commit('SET_IS_SENDING_REQUEST_MODAL')

        const preparedMaterials = this.rows.map(item => ({
          id: item.rodLength?.id,
          amount: item.totalWeight ? toNum(item.totalWeight) : null,
          count: item.count ? toNum(item.count) : null
        }))

        // Проверяем: все ли материалы пустые?
        const allEmpty = preparedMaterials.every(mat =>
          !mat.id && !mat.amount && !mat.count
        )
        // Если материалы пустые отправляем в materials - null, для удаления резерва
        const params = {
          materials: allEmpty ? null : preparedMaterials
        }

        await this.setReserveMaterial({ id: this.positionId, data: params })

        this.onReject()
      } finally {
        this.$store.commit('SET_IS_SENDING_REQUEST_MODAL', false)
      }
    },
    onReject () {
      this.$emit('reject')
    }
  }
}
</script>
